import { Link } from "react-router-dom";
import { Phone, FileText, Clock, Shield } from "lucide-react";
import { COMPANY } from "@/lib/siteData";

export default function CtaBand() {
  return (
    <section className="bg-[#001B35] text-white dark-grain" data-testid="cta-band">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <p className="text-xs uppercase tracking-[0.24em] text-[#9bb6d6] mb-3">Un projet ? Un dépannage ?</p>
          <h2 className="font-display text-3xl sm:text-4xl font-bold leading-tight">Parlons-en dès maintenant.</h2>
          <p className="mt-4 text-[#cfdbe8] max-w-xl">
            Un conseil rapide, un devis gratuit, une intervention d'urgence : nous sommes à votre écoute.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <a href={`tel:${COMPANY.phoneTel}`} data-testid="ctaband-phone" className="inline-flex items-center gap-2 bg-[#005BBB] hover:bg-[#0072e8] rounded-full px-6 py-3 font-semibold transition btn-shine">
              <Phone className="w-4 h-4" /> {COMPANY.phone}
            </a>
            <Link to="/contact" data-testid="ctaband-devis" className="inline-flex items-center gap-2 bg-[#D90000] hover:bg-[#b00000] rounded-full px-6 py-3 font-semibold transition btn-shine">
              <FileText className="w-4 h-4" /> Demander un devis
            </Link>
          </div>
        </div>

        <div className="grid sm:grid-cols-3 gap-4">
          {[
            { icon: FileText, label: "Devis gratuit", sub: "Réponse rapide" },
            { icon: Clock, label: "Intervention rapide", sub: "Délais respectés" },
            { icon: Shield, label: "Travail soigné", sub: "Qualité garantie" },
          ].map(({ icon: Icon, label, sub }) => (
            <div key={label} className="border border-white/10 rounded-2xl p-5 bg-white/[0.03]">
              <div className="w-10 h-10 rounded-xl bg-[#005BBB]/20 flex items-center justify-center mb-3">
                <Icon className="w-5 h-5 text-[#9bb6d6]" />
              </div>
              <p className="font-semibold">{label}</p>
              <p className="text-sm text-[#9bb6d6]">{sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
